//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO CARD PARA PREENCHIMENTO DE             //   
//  INFORMAÇÕES LOGIN E SENHA NA PÁGINA DE LOGIN        //   
//                                                      //   
//  FUNCIONALIDADE: REALIZAR O LOGIN                    //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/login.js                                     //
//                                                                      //
//////////////////////////////////////////////////////////////////////////


import React from "react"

import api from "../services/api";


function FormLogin() {

    async function teste_submit(){  // FUNÇÃO PARA VERIFICAR SE O SUBMIT DAS INFORMAÇÕES PODE SER FEITO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Login' DESTE COMPONENTE

        for (var i = 1; i < 3; i++){  // REMOVE ERROS ANTERIORES
            document.getElementsByTagName('input')[i].classList.remove('border-erro')
        }

        var dict_dados = {'acao': 'login'}  // CRIA O DICIONÁRIO PARA REALIZAR A ALTERAÇÃO NA BASE DE DADOS
        var submit = true
        for (i = 1; i < 3; i++){  // PARA CADA ITEM, VERIFICA SE AS INFORMAÇÕES ESTÃO PREENCHIDAS
            var item  = document.getElementsByTagName('input')[i] 
            if(item.value !== ''){  // CASO O ITEM NÃO ESTIVER VAZIO
                dict_dados[item.id] = item.value  // ADICIONA AS INFORMAÇÕES NO DICIONÁRIO
            }  
            else{  // CASO O ITEM ESTEJA VAZIO
                submit = false  // NÃO PERMITE O SUBMIT
                item.classList.add('border-erro')  // E APONTA O ERRO
            }
        }   
        
        if (submit){  // CASO O SUBMIT SEJA POSSÍVEL
            if(document.getElementById('titulo').innerText !== 'CNPJ'){  // E O LOGIN FOR COMO CLIENTE
            
                var login = await api.post('login',{  // REALIZA A VERIFICAÇÃO DE DADOS NA TABELA DE CLIENTES DO DB
                    dict_dados
                }).then((response) => {
                    return response
                })
                // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
                  // 'login' -> BOOLEANO QUE INDICA SE O LOGIN PODE OU NÃO SER REALIZADO

                  // 'data' -> STRING
                    // CASO 'login' SEJA FALSO, RETORNA UMA MENSAGEM DO PORQUE (SENHA ERRADA, USUÁRIO NÃO ENCONTRADO, ETC) 
                    // CASO 'login' SEJA TRUE, RETORNA O TOKEN DO USUÁRIO CADASTRADO 

                if (!login.data.login){  // CASO O LOGIN NÃO FOI POSSÍVEL
                    document.getElementById('msg_login').innerText = login.data.data  // APONTA O ERRO DADO PARA O USUÁRIO
                }
                else{ // CASO O LOGIN TENHA SIDO REALIZADO
                    sessionStorage.setItem('login', login.data.data)  // ADICIONA O TOKEN DO USUÁRIO NA SESSÃO (UM TOKEN NA SESSÃO INDICA QUE O USUÁRIO ESTÁ LOGADO)
                    add_session_db()  // ADICIONA NO DB AS INFORMAÇÕES DOS PRODUTOS NO CARRINHO
                    
                    var id_loja = sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
                    window.location.href = '/?id='+ id_loja
                }
            }
            else{  // CASO O LOGIN TENHA SIDO FEITO COMO FRANQUEADO
                login = await api.post('login_loja',{  // REALIZA A VERIFICAÇÃO DE DADOS NA TABELA DE FRANQUEADOS DO DB
                    dict_dados
                }).then((response) => {
                    return response
                })
                // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
                  // 'login' -> BOOLEANO QUE INDICA SE O LOGIN PODE OU NÃO SER REALIZADO

                  // 'data' -> STRING
                    // CASO 'login' SEJA FALSO, RETORNA UMA MENSAGEM DO PORQUE (SENHA ERRADA, USUÁRIO NÃO ENCONTRADO, ETC) 
                    // CASO 'login' SEJA TRUE, RETORNA O TOKEN DO USUÁRIO CADASTRADO                 
                
                if (!login.data.login){  // CASO O LOGIN NÃO FOI POSSÍVEL
                    document.getElementById('msg_login').innerText = login.data.data  // APONTA O ERRO DADO PARA O USUÁRIO
                }
                else{  // CASO O LOGIN TENHA SIDO REALIZADO
                    sessionStorage.setItem('login', '/' + login.data.data + '/')  // ADICIONA O TOKEN DO FRANQUEADO NA SESSÃO ENTRE / 
                                                                                    // (UM TOKEN ENTRE / NA SESSÃO INDICA QUE O USUÁRIO ESTÁ LOGADO COMO FRANQUEADO)
                    
                    id_loja = sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
                    window.location.href = '/?id='+ id_loja
                }                
            }
        }
    }

    
    async function add_session_db(){  // FUNÇÃO PARA ADICIONAR OS PRODUTOS QUE ESTÃO NO CARRINHO (SALVOS NA SESSAO) NO DB
        // FUNÇÃO CHAMADA APÓS O SUCESSO DO LOGIN NA FUNÇÃO 'teste_submit' NESSE COMPONENTE

        var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // CRIA O DICIONÁRIO PARA ADICIONAR OS PRODUTOS NO DB
        if (sessionStorage['favoritar']){  // FAVORITAR ESTÁ SEMPRE VAZIO POIS FOI RETIRADO A PEDIDO DO DEPARTAMENTO DE MARKETING
            dict_itens['favoritar'] = sessionStorage['favoritar']
        }
        if (sessionStorage['comprar']){  // PEGA OS PRODUTOS NO CARRINHO DA SESSAO
            var itens = sessionStorage['comprar'].split(';') 

            for(var i = 0; i < itens.length; i++){  // PARA CADA ITEM
                var dict = JSON.parse(itens[i])  // PEGA AS INFORMAÇÕES NO FORMATO CORRETO
                dict_itens['comprar'] = dict['id']
                dict_itens['quantidade'] = dict[dict['id']]['carrinho']


                var produtos = await api.post('add_session_db',{  // E SALVA NO DB
                    dict_itens
                  }).then((response) => {
                    return response
                  })
                // 'produtos' NÃO RETORNA NADA
        
            }
        }      
    }


    return(  // RENDERIZA O COMPONENTE 

      <div>
        <p class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">Usuário</p>
        <div class="border-bottom-black p-4">
            <div class='col col-12 row px-0 mx-0 mb-3'>
                <div class="col-12 p-0 mx-0">
                    <h5 id='titulo' class='montserrat verde'>E-mail/CPF/Telefone Celular</h5>
                    <input id='login' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                </div>
            </div>    
            <div class='col col-12 row px-0 mx-0'>
                <div class="col-12 p-0 mx-0">
                    <h5 class='montserrat verde'>Senha</h5>
                    <input id='senha_login' class='w-100 no-outline busca border-redonda tamanho-filtro px-2' type='password'></input>
                </div>         

            </div>            
        </div>


        <div class="my-4">
            <div class='col col-12 row px-2 mx-0'>
                <div class="px-0 row col col-12 mx-0">
                    <div id='msg_login' class='mx-0 px-0 vermelha montserrat col-9'>

                    </div>
                    <div class="col-3 px-0 mx-0">
                      <button class="btn-verde pull-right" onClick={teste_submit}>
                        <i class="fa fa-check mr-4 montserrat"></i>Login
                      </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
    )
}

export default FormLogin;
